import React from 'react';
import styles from './LinkedContainer.module.scss';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';

const LinkedTime = ({ time, onClick }) => {
  const myRef = useAccessibleClick(onClick);

  return (
    <div ref={myRef} tabIndex={0} className={styles.time} onClick={onClick}>
      {time}
    </div>
  )
}

export default LinkedTime;